import { usePaperFlip } from '../../hooks/usePaperFlip'
import { useBookStore } from '../../stores'

const buttonBase: React.CSSProperties = {
  padding: '8px 16px',
  borderRadius: '8px',
  border: 'none',
  color: 'white',
  cursor: 'pointer',
  fontSize: '14px',
  transition: 'background 0.15s ease',
}

const disabledStyle: React.CSSProperties = { ...buttonBase, background: '#666', cursor: 'not-allowed' }
const activeStyle: React.CSSProperties = { ...buttonBase, background: '#4ade80' }

export default function Navigation() {
  const { currentPage, totalPages } = useBookStore()
  const { flipToNext, flipToPrev, canFlipNext, canFlipPrev, isFlipping } = usePaperFlip()

  return (
    <div style={{
      position: 'fixed',
      bottom: '80px',
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      gap: '12px',
      zIndex: 100,
      background: 'rgba(0,0,0,0.5)',
      padding: '12px 24px',
      borderRadius: '24px',
      opacity: isFlipping ? 0.6 : 1,
      pointerEvents: isFlipping ? 'none' : 'auto',
    }}>
      <button
        onClick={flipToPrev}
        disabled={!canFlipPrev}
        style={canFlipPrev ? activeStyle : disabledStyle}
      >
        上一页
      </button>

      <span style={{ color: 'white', lineHeight: '32px' }}>
        {currentPage + 1} / {totalPages}
      </span>

      <button
        onClick={flipToNext}
        disabled={!canFlipNext}
        style={canFlipNext ? activeStyle : disabledStyle}
      >
        下一页
      </button>
    </div>
  )
}